<template>
  <v-dialog v-model="dialog" max-width="400" persistent>
    <div class="logs">
      <v-card>
        <v-card-title class="navy headline">
          <span class="white--text">Registro Eventi</span>
          <v-spacer></v-spacer>
          <v-btn depressed class="white--text" light icon @click="dismiss">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>
        <div v-if="astaLogs && _.size(astaLogs) > 0">
          <v-list
            dense
            class="overflow-y-auto mr-1 pr-1"
            max-height="450px"
            :class="{ 'nice-scroll': !is_mobile }"
          >
            <!-- https://stackoverflow.com/questions/56449591/what-key-to-use-for-v-for-when-elements-have-no-id -->
            <v-list-item v-for="log in astaLogs" :key="log.key">
              <v-list-item-content>
                <asta-log small :log="log"> </asta-log>
              </v-list-item-content>
              <v-list-item-action class="timestamp">
                {{ log.tsFormatted }}
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </div>
        <div class="lista-vuota py-4" v-else>Nessun evento.</div>

        <div
          v-if="!loadingLogs && !noMoreLogs && astaLogs && _.size(astaLogs) > 0"
          class="d-flex justify-center"
          style="height: 50px"
        >
          <v-btn icon @click="loadMore">
            <v-icon class="navy--text">expand_more</v-icon>
          </v-btn>
        </div>

        <div
          v-if="loadingLogs"
          class="d-flex justify-center"
          style="height: 50px"
        >
          <v-progress-circular
            indeterminate
            class="navy--text"
          ></v-progress-circular>
        </div>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
import db from "../../js/db";
import Constants from "../../js/constants";
import * as Helpers from "../../js/helpers";
import mixins from "../../js/mixins";
import Vuex from "vuex";
import AstaLog from "../common/AstaLog";

export default {
  name: "asta-logs",
  mixins: [mixins],
  components: { AstaLog },
  data() {
    return {
      dialog: false,
      nItems: Constants.LOG_PAGINATOR,
    };
  },
  mounted() {
    console.log("--> AstaLogs ready.");
    db.on("showAstaLogs", this.show);
  },
  destroyed() {
    console.log("<-- AstaLogs destroyed.");
    db.off("showAstaLogs", this.show);
  },
  watch: {
    dialog: {
      handler(val) {
        if (val) {
          this.$store.dispatch("setAstaLogsAll", this.nItems);
        }
      },
      immediate: true,
    }
  },
  methods: {
    show() {
      this.dialog = true;
    },
    dismiss() {
      this.$store.dispatch("clearAstaLogsAll");
      this.dialog = false;
    },
    loadMore() {
      this.$store.dispatch("setAstaLogsAll", this.nItems);
    },
  },
  computed: {
    ...Vuex.mapGetters(["astaLogs", "is_mobile", "loadingLogs", "noMoreLogs"]),
  },
};
</script>
<style lang="scss" scoped>
.lista-vuota {
  width: 100%;
  text-align: center;
}
.timestamp {
  font-size: 10px;
}
</style>
